import { render, staticRenderFns } from "./PhysicalExams.vue?vue&type=template&id=034bb32d&scoped=true"
import script from "./PhysicalExams.vue?vue&type=script&lang=js"
export * from "./PhysicalExams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034bb32d",
  null
  
)

export default component.exports